import React from "react"
import { concatStrings } from "../utilities"
import Section from "./section"
import DfbRte from "../ui-kit/dfb_rte"
import DfbImage from "../ui-kit/dfb_image"
import DfbQuote from "../ui-kit/dfb_quote"
import CTextimage from "../elements/c_textimage"

const MTab = (props) => {
  const tabContent = (item) => {
    if (item.text && item.image) {
      return <CTextimage data={item} />
    } else if (item.text) {
      return <DfbRte text={item.text} />
    } else if (item.image) {
      return <DfbImage image={item.image} aspect_ratio={item.aspect_ratio} />
    } else if (item.quote_author && item.quote_with_image === 0) {
      return (
        <DfbQuote
          text={item.plaintext}
          quote_author={item.quote_author}
          quote_author_position={item.quote_author_position}
        />
      )
    } else if (item.quote_author && item.quote_with_image === 1) {
      return (
        <CTextimage
          data={{ ...item, image: item.image_quote[0].image, quote: true }}
        />
      )
    } else {
      return null
    }
  }
  return (
    <Section baseClass="m-Tab" data={props.data}>
      <div className="m-Tab-wrapper">
        <div className="m-Tab-container">
          <div className="m-Tab-tabContainer">
            <div className="dfb-Tabs dfb-Tabs--simple m-Tab-tabs">
              <div className="dfb-Tabs-scroller">
                <div className="dfb-Tabs-scrollArea">
                  <div className="dfb-Tabs-scrollContent">
                    <ul className="dfb-Tabs-list">
                      {props.data.tab_item.map((tab_item, index) => (
                        <li className="dfb-Tabs-item" key={index}>
                          <a
                            className="dfb-Tabs-tab"
                            href={
                              "#m-tabs-" +
                              props.data.uid +
                              "-panel-" +
                              (index + 1)
                            }
                            id={
                              "m-tabs-" + props.data.uid + "-tab-" + (index + 1)
                            }
                            tabIndex={index > 0 ? -1 : 0}
                          >
                            <div className="dfb-Tabs-labelContainer">
                              <span className="dfb-Tabs-tabLabel">
                                {tab_item.tab_item_title}
                                {tab_item.tab_item_content.headline}
                              </span>
                            </div>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <button
                  type="button"
                  tabIndex={-1}
                  disabled
                  className="dfb-Tabs-paddle dfb-Tabs-paddleLeft"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M14 6.47l1.06 1.06L10.591 12l4.469 4.47L14 17.53 8.47 12 14 6.47z" />
                  </svg>
                </button>
                <button
                  type="button"
                  tabIndex={-1}
                  disabled
                  className="dfb-Tabs-paddle dfb-Tabs-paddleRight"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M10.03 17.53l-1.06-1.06L13.439 12 8.97 7.53l1.06-1.06L15.561 12l-5.531 5.53z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="m-Tab-panelContainer">
            {props.data.tab_item.map((tab_item, index) => (
              <div
                className={concatStrings(
                  "dfb-TabsPanel m-Tab-panel",
                  index === 0 && "is-active"
                )}
                id={"m-tabs-" + props.data.uid + "-panel-" + (index + 1)}
                role="tabpanel"
                tabIndex={index === 0 ? 0 : -1}
                aria-labelledby={
                  "m-tabs-" + props.data.uid + "-tab-" + (index + 1)
                }
                key={index}
              >
                {tab_item.tab_item_content.map((item, index) => (
                  <div className="m-Tab-panel" key={index}>
                    {tabContent(item)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MTab
